import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import ClockDatetime from 'Component/clock-datetime';

import styles from './styles.module.css';

const AttendanceOverviewContent = ({ clockInTime }) => {
  const { t } = useTranslation('host-home');

  return (
    <Box className={styles['attendance-overview-content__section']}>
      <ClockDatetime label={t('attendance.clock_in')} time={moment(clockInTime).format('HH:mm')} date={moment(clockInTime).format('DD/MM/YY')} />
      <ClockDatetime label={t('attendance.clock_out')} time="-" date="-" />
    </Box>
  );
};

export default AttendanceOverviewContent;
